import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,_vm._b({attrs:{"label":"Selecione o tipo de relatório","items":_vm.items,"item-text":"descricao","item-value":"id","auto-select-first":"","return-object":""},model:{value:(_vm.relatorioSelecionado),callback:function ($$v) {_vm.relatorioSelecionado=$$v},expression:"relatorioSelecionado"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }